
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.778 18.778"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 937"}},[_c('path',{attrs:{"data-name":"Path 7096","d":"M14.068 0H4.694A4.716 4.716 0 000 4.709v9.374a4.713 4.713 0 004.694 4.694h9.374a4.719 4.719 0 004.709-4.709V4.709A4.719 4.719 0 0014.068 0zm-3.74 12a2.011 2.011 0 01-1.7-.835s-.4 1.55-.492 1.848a7.339 7.339 0 01-1.252 2.206.092.092 0 01-.164-.045 7.744 7.744 0 01.015-2.563l.894-3.666a2.5 2.5 0 01-.224-1.058c0-1 .6-1.744 1.341-1.744a.919.919 0 01.939 1.013 14.054 14.054 0 01-.611 2.384 1.052 1.052 0 001.1 1.3c1.311 0 2.206-1.639 2.206-3.577 0-1.475-1.028-2.578-2.891-2.578A3.249 3.249 0 006.066 7.9a1.93 1.93 0 00.462 1.326c.134.149.149.209.1.373-.03.119-.1.417-.149.537a.234.234 0 01-.343.164 2.583 2.583 0 01-1.412-2.58c0-1.908 1.669-4.2 4.963-4.2a4.1 4.1 0 014.4 3.86c-.019 2.65-1.524 4.62-3.759 4.62z","fill":"#fff"}})])])
          )
        }
      }
    